
import caseList from './list/medicalUnionPush'
import Confirm from 'vux/src/components/confirm/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import Vue from 'vue'
import Scroll from '../../base/scroll/scroll'

export default {
components: {
caseList,
Scroll,
Confirm,
Alert,
XDialog
},
data () {
return {
$vue: '',
toLeft: true,
toBottom: false,
caseListOption: [],
searchCondition: new Map(),

openIndex: -1,
listData: [],
clickedCaseId: '',
scrollbar: true,
scrollbarFade: true,
pullDownRefresh: true,
pullDownRefreshThreshold: 90,
pullDownRefreshStop: 40,
pullUpLoad: true,
pullUpLoadThreshold: 0,
startY: 0,
scrollToX: 0,
scrollToY: -200,
scrollToTime: 700,
scrollToEasing: 'bounce',
showInvalid: false,
showError: false,
refreshResult: ''
}
},
computed: {

scrollbarObj: function () {
return this.scrollbar ? {fade: this.scrollbarFade} : false
},

pullDownRefreshObj: function () {
return this.pullDownRefresh ? {
threshold: parseInt(this.pullDownRefreshThreshold),
stop: parseInt(this.pullDownRefreshStop)
} : false
},

pullUpLoadObj: function () {
return this.pullUpLoad ? {
threshold: parseInt(this.pullUpLoadThreshold),
txt: {more: this.pullUpLoadMoreTxt, noMore: this.pullUpLoadNoMoreTxt}
} : false
}
},
methods: {

async initDocList () {

this.caseListOption = []




let dmzOption = []
dmzOption.url = this.$vue.getData('MEDICAL_UNION_DOC_LIST')
dmzOption.listName = '医生列表'
dmzOption.caseListType = 'mz'

this.caseListOption.push(dmzOption)
},

caseEvent (prop) {
this.clickedCaseId = prop.caseId
this.$router.push({ path: '/medicalcaselist/' + this.clickedCaseId.toString() })
},

axiosPackage (url) {
let params = new URLSearchParams()
params.append('CASE_ID', this.clickedCaseId.toString())
return this.$http.post(url, params)
},

showInvalidConfirm () {
this.showInvalid = true
},

async startMz () {

this.$router.push({ path: '/medicalunionpush/' + this.clickedCaseId.toString() })
},

getRefreshResult (prop) {
this.refreshResult = prop.result
},

onPullingDown () {

this.$refs.mz[0].refreshList()
setTimeout(() => {

this.$refs.scroll.forceUpdate()
}, 2000)
},

onPullingUp () {

setTimeout(() => {

this.$refs.scroll.forceUpdate()
}, 1500)
},
scrollToCaseList () {

setTimeout(this.scrollTo, 200)
},
scrollTo () {

let listHeight = document.querySelector('.conterUl').offsetHeight
this.$refs.scroll.scrollTo(-listHeight + 676)
},
updateScrollbar (val) {
this.scrollbar = val
},
updateScrollbarFade (val) {
this.scrollbarFade = val
},
updatePullDownRefresh (val) {
this.pullDownRefresh = val
},
updatePullDownRefreshThreshold (val) {
this.pullDownRefreshThreshold = val
},
updatePullDownRefreshStop (val) {
this.pullDownRefreshStop = val
},
updatePullUpLoad (val) {
this.pullUpLoad = val
},
updatePullUpLoadThreshold (val) {
this.pullUpLoadThreshold = val
},
updatePullUpLoadMoreTxt (val) {
this.pullUpLoadMoreTxt = val
},
updatePullUpLoadNoMoreTxt (val) {
this.pullUpLoadNoMoreTxt = val
},
updateStartY (val) {
this.startY = val
},
updateScrollToX (val) {
this.scrollToX = val
},
updateScrollToY (val) {
this.scrollToY = val
},
updateScrollToTime (val) {
this.scrollToTime = val
},
updateScrollToEasing (val) {
this.scrollToEasing = val
},
rebuildScroll () {
Vue.nextTick(() => {
this.$refs.scroll.destroy()
this.$refs.scroll.initScroll()
})
}
},
beforeMount () {

this.$vue = this

this.searchCondition = this.$route.params.searchCondition


this.initDocList()
},
beforeRouteEnter (to, from, next) {
next(vm => {

if (from.name === 'diagnosis' || from.name === 'reportdetail') {

let listType = localStorage.getItem('listType')

eval('vm.$refs.' + listType + '[0].openListAndSetPage()')
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/caselist/medicalCaseList.vue